import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/creators/{creatorId}/calendar-sync']['POST'];
type Input = ThisApi['params'];
type Output = ThisApi['response'];

const synchronizeCreatorCalendar = async ({ creatorId }: Input): Promise<Output> => {
  const response = await noodleApiClient.post(`/creators/${creatorId}/calendar-sync`);
  return response.data;
};

export default synchronizeCreatorCalendar;
